<template>
  <div>
    <label>
      <template v-if="model == 1">
        <vk-icon icon="check" style="color:green;" />
      </template>
      <template v-else>
        <vk-icon icon="minus" style="color:grey;" />
      </template>
    </label>
  </div>
</template>

<script>
export default {
  name: "status",
  data() {
    return {
      model: 1
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = 1;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
